module.exports = __webpack_public_path__ + "media/img/home/product/mobile/product1-68c71bac3396aa71683701bddd66313e.svg";